export default () => ({
    goBack() {
        window.history.back();
    },
})